import { CircleSlash, Droplets, Flame, Leaf, Mountain, Sword } from "lucide-react";
import { type DamageElement } from "../types";

export const ELEMENT_LABELS: Record<DamageElement | "weapon", string> = {
  neutral: "无属性",
  water: "水",
  fire: "火",
  earth: "土",
  wood: "木",
  weapon: "继承武器",
};

export const ELEMENT_ADVANTAGE_TARGETS: Record<DamageElement, DamageElement | null> = {
  neutral: null,
  water: "fire",
  fire: "wood",
  earth: "water",
  wood: "earth",
};

export function ElementIcon({
  element,
  size = 13,
}: {
  element: DamageElement | "weapon";
  size?: number;
}) {
  if (element === "water") return <Droplets size={size} />;
  if (element === "fire") return <Flame size={size} />;
  if (element === "earth") return <Mountain size={size} />;
  if (element === "wood") return <Leaf size={size} />;
  if (element === "weapon") return <Sword size={size} />;
  return <CircleSlash size={size} />;
}

export function ElementMark({
  element,
  label,
  size = 9,
  className = "",
}: {
  element: DamageElement | "weapon";
  label: string;
  size?: number;
  className?: string;
}) {
  return (
    <i
      className={`element-mark element-${element}${className ? ` ${className}` : ""}`}
      title={label}
      aria-label={label}
      role="img"
    >
      <ElementIcon element={element} size={size} />
    </i>
  );
}

export function AttackElementMark({
  element,
  className,
  size,
}: {
  element: DamageElement | "weapon";
  className?: string;
  size?: number;
}) {
  if (element === "weapon")
    return <ElementMark element={element} label="继承武器属性" className={className} size={size} />;
  if (element === "neutral")
    return (
      <ElementMark
        element={element}
        label="无属性伤害：不触发属性倍率"
        className={className}
        size={size}
      />
    );
  const advantageTarget = ELEMENT_ADVANTAGE_TARGETS[element];
  const label = `${ELEMENT_LABELS[element]}属性伤害：对${ELEMENT_LABELS[advantageTarget!]}属性目标 1.5 倍伤害、对${ELEMENT_LABELS[element]}属性目标 0.75 倍伤害`;
  return <ElementMark element={element} label={label} className={className} size={size} />;
}

export function TargetElementMark({
  resistance,
  weakness,
}: {
  resistance: DamageElement;
  weakness: DamageElement;
}) {
  const label =
    resistance === "neutral"
      ? "无属性：不触发属性倍率"
      : `${ELEMENT_LABELS[weakness]}属性 1.5 倍伤害、${ELEMENT_LABELS[resistance]}属性 0.75 倍伤害`;
  return <ElementMark element={resistance} label={label} />;
}

export function EquipmentElementMark({ element }: { element?: DamageElement }) {
  if (!element || element === "neutral") return null;
  return <AttackElementMark element={element} className="tile-element-mark" size={7} />;
}
